import { useCallback } from 'react';

import { ScheduleTaskDocument, ScheduleTaskRequirementsDocument, TaskListDocument } from 'src/generated/mloop-graphql';

import { useApolloRefetchQuery } from 'src/hooks/useApolloQuery';

/** GraphQL operation names refetched when schedule task data changes (e.g. taskUpdated subscription). */
export const SCHEDULE_TASK_RELATED_QUERY_NAMES = ['ScheduleTask', 'ScheduleTaskRequirements', 'TaskList'] as const;

const useRefetchScheduleTaskQuery = () => {
  const apolloRefetchQuery = useApolloRefetchQuery();

  return useCallback(async () => {
    // TaskList powers candidate-page task cards; keep it in sync with schedule drawer updates.
    await apolloRefetchQuery([ScheduleTaskDocument, ScheduleTaskRequirementsDocument, TaskListDocument]);
  }, [apolloRefetchQuery]);
};

export default useRefetchScheduleTaskQuery;
